// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5597) return "static/chunks/5597-b8ef7cf0a396260d.js";
	if (chunkId === 3566) return "static/chunks/3566-73def975fe393e85.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2279":"3692729c8b47fd24","9511":"0502aa13ad3ccb6c"}[chunkId] + ".js";
};